<app-page-content-wrapper>
  <ng-container *ngIf="(seller$ | async) && (tabs$ | async)?.length; else notFound">
    <div class="seller-header">
      <div
        class="seller-header__title"
        fxFlex="100%"
        fxFlexOffset="20%"
        fxFlexOffset.mm-mobile="0"
        fxFlexOffset.mm-tablet="30%"
        fxLayout.mm-mobile="row wrap"
        fxLayoutAlign="space-between center"
      >
        <h2 fxFlex.mm-mobile="100%" fxFlexOrder.mm-mobile="1">
          {{ (seller$ | async)?.shopName }}
        </h2>
        <app-storefront-seller-avatar
          [fullName]="(seller$ | async)?.shopName"
          [imageUrl]="(seller$ | async)?.logo?.url"
          fxFlexOrder.mm-mobile="0"
          mode="medium"
        >
        </app-storefront-seller-avatar>
      </div>
    </div>
    <div class="seller-content">
      <app-storefront-tabs [tabs]="tabs$ | async"> </app-storefront-tabs>
    </div>
  </ng-container>
</app-page-content-wrapper>
<ng-template #notFound>
  <app-shared-page-loading></app-shared-page-loading>
</ng-template>
